import { useEffect, useState } from "react";
import { Box, LinearProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AuthenticationService from "../../../services/authentication.service";
import { RouteNames } from "../../../enums/RouteNames";
import Notification from "../../../views/notification/Notification";
import { NotificationSeverities } from "../../../enums/NotificationSeverities";

const DEFAULT_ERROR_MESSAGE = 'Something went wrong during logging.'

const AutomaticLogin = () => {
  const [errorMessage, setErrorMessage] = useState<string>(DEFAULT_ERROR_MESSAGE);
  const [isErrorNotificationOpen, setIsErrorNotificationOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const abortController = new AbortController();

    AuthenticationService
      .getUserManager()
      .signinRedirect()
      .catch((error: Error) => {
        setErrorMessage(error.message.length > 0 ? error.message : DEFAULT_ERROR_MESSAGE);
        setIsErrorNotificationOpen(true);
        setTimeout(() => navigate(RouteNames.LOGIN), 2000);
      });

    return () => abortController.abort();
  }, [navigate]);

  return (
    <>
      <Box>
        <LinearProgress className='p-1' color='success' />
      </Box>
      <Notification
        open={isErrorNotificationOpen}
        onClose={() => setIsErrorNotificationOpen(false)}
        message={errorMessage}
        severity={NotificationSeverities.ERROR}
      />
    </>
  );
};

export default AutomaticLogin;
